import {ApiClient} from './api'

export class AdyenPaymentsService {
    baseUrl = '/mobify/api/adyen/payments'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async submitPayment(adyenStateData, basketId, customerId, locale) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                data: adyenStateData,
            }),
            headers: {
                customerid: customerId,
                basketid: basketId,
                locale,
            },
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
